import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import WizardServerError from '../../../../model/WizardServerError';
import { ModularListingContext } from '../../../../containers/CreateListingPage/context';
import { WizardContext } from '../../../Wizard/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';

import PropertiesActions from '../../../../actions/PropertiesActions';
import actions from '../../../../containers/CreateListingPage/actions';
import wizardActions from '../../../Wizard/actions';

import Scheduler from '../../../Scheduler';
import WizardAlert from '../../../WizardAlert';

const propTypes = {
  hideTitle: PropTypes.bool,
  hideLabel: PropTypes.bool,
  textStyle: PropTypes.string,
};

const defaultProps = {
  hideTitle: false,
  hideLabel: false,
  textStyle: 'heading-sm',
};

const fieldName = 'schedule';

const SchedulerFormField = ({ hideLabel, hideTitle, textStyle }) => {
  const dispatch = useDispatch();
  const { reducerWizardDispatch } = useContext(WizardContext);

  const {
    modularListingState: { isInModalState, serverErrorObj },
    reducerDispatch,
  } = useContext(ModularListingContext);

  const {
    user: {
      features: { canUpdateListing },
    },
    properties: {
      currentProperty: {
        schedule,
        listingAlias,
        isArchived,
        restrictions: { isUpdateListingRestricted },
      },
    },
  } = useSelector((state) => state);

  const isDisabled = !canUpdateListing || isArchived || isUpdateListingRestricted;

  const clearServerError = () => {
    if (serverErrorObj.fieldName) {
      actions.removeServerError({
        reducerDispatch,
      });
    }
  };

  const updateClpState = (data) => {
    clearServerError();
    dispatch(PropertiesActions.updateCurrentProperty({ schedule: data.schedule }));
  };

  const updateFetchingStatus = (isFetching = false) => {
    wizardActions.updateIsFetchingData({ reducerWizardDispatch, isFetchingData: isFetching });
  };

  const updateServerError = (message = '', fieldName = '') => {
    const displayAt = isInModalState ? DISPLAY_SERVER_ERROR_AT.FIELD : DISPLAY_SERVER_ERROR_AT.PAGE;

    actions.updateServerError({
      reducerDispatch,
      serverErrorObj: WizardServerError({
        displayAt,
        fieldName,
        message,
        displayMessage: message,
      }),
    });
  };

  const handleError = (message) => {
    updateServerError(message, fieldName);
  };

  return (
    <div data-test="SchedulerFormField">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.FIELD} />

      <Scheduler
        textStyle={textStyle}
        hideLabel={hideLabel}
        hideTitle={hideTitle}
        isInputFormDisabled={isDisabled}
        listingAlias={listingAlias}
        onError={handleError}
        schedule={schedule}
        updateFormData={updateClpState}
        updateFetchingStatus={updateFetchingStatus}
      />
    </div>
  );
};

SchedulerFormField.propTypes = propTypes;
SchedulerFormField.defaultProps = defaultProps;

export default SchedulerFormField;
